import { Address } from '@app/models/Address';
import { CompleteRegistrationRequest } from '@app/models/CompleteRegistrationRequest';
import { HomeownerMarketingAgreement } from '@app/models/HomeownerMarketingAgreement';
import { ContactApi } from '@app/services/apiServices/ContactApi';
import { HeaderService } from '@app/components/header/header.service';
import { Homeowner } from '@app/models/Homeowner';
import { Property } from '@app/models/Property';
import { RegistrationRequest } from '@app/models/RegistrationRequest';
import { HomeownerApi } from '@app/services/apiServices/HomeownerApi';
import { PropertyApi } from '@app/services/apiServices/PropertyApi';
import { RegistrationApi } from '@app/services/apiServices/RegistrationApi';
import { MobileLoginService } from '@app/services/MobileLogin.service';
import { NetworkErrorService } from '@app/services/NetworkError.service';
import { OauthService } from '@app/services/oauth.service';
import { ScrollService } from '@app/services/Scroll.service';
import { SpinnerService } from '@app/services/spinner.service';
import { GuestPaymentStore } from '@app/services/stores/GuestPaymentStore';
import { RegistrationStore } from './stores/RegistrationStore';
import { take } from "rxjs/operators";
import { Component, Inject, NgZone, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { WindowToken } from "@app/util/window.token";
import { AppDataService } from "@app/services/appData.service";
import { DomSanitizer } from "@angular/platform-browser";
import { RegistrationAltDetailsCouponDialog } from "@app/pages/registration/registrationAltDetailsCoupon.dialog";
import { RegistrationFoundPropertyDialog } from "@app/pages/registration/registrationFoundProperty.dialog";
import { SecurityQuestionsConfirmDialog } from "@app/pages/registration/securityQuestionsConfirm.dialog";
import {
    RegistrationAltAddressNeedsCorrectionDialog
} from "@app/pages/registration/registrationDialogAltAddressNeedsCorrection.component";
import { RegistrationAltAddressDialog } from "@app/pages/registration/registrationDialogAltAddress.component";
import { RegistrationInvalidAddressDialog } from "@app/pages/registration/registrationDialogInvalidAddress.component";
import { RegistrationStopHoldDialog } from "@app/pages/registration/registrationDialogStopHold.component";
import { RegistrationNoPropertyDialog } from "@app/pages/registration/registrationDialogNoProperty.component";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { ErrorHandlerService } from "@app/services/ErrorHandler.service";

@Component({
    selector: 'app-registration-step-2',
    template: require('./registrationStep2.html')
})
export class RegistrationStep2Component implements OnInit {

    homeowner: Homeowner;
    property: Property = { address: {}, hoa: { pmc: {} } };
    uiViewName_BY_ADDRESS: string = 'byAddress';
    uiViewName_BY_IDS: string = 'byIds';
    uiSelectedViewName: string;
    isLoadingFindMyProperty: boolean = false;
    disableInputsProperty: boolean = false;
    searched: boolean = false;
    invalidCheckVar: boolean = false;
    isCorrectingAddress: boolean = false;
    setPropertyAddressSubject: Subject<void> = new Subject<void>();

    getWebUrl: () => string;
    getPmcContactUrl = (pmcId: string) => this.getWebUrl() + `/guest/#/contact/?pmcId=${pmcId}`;

    constructor(
        @Inject(PropertyApi) private propertyApi: PropertyApi,
        @Inject(OauthService) private OauthService: OauthService,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(WindowToken) private $window: Window,
        @Inject(HeaderService) private headerService: HeaderService,
        @Inject(RegistrationStore) private registrationStore: RegistrationStore,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(GuestPaymentStore) private guestPaymentStore: GuestPaymentStore,
        @Inject(ScrollService) private scrollService: ScrollService,
        @Inject(ContactApi) private contactApi: ContactApi,
        @Inject(RegistrationApi) private registrationApi: RegistrationApi,
        @Inject(HomeownerApi) private homeownerApi: HomeownerApi,
        @Inject(MobileLoginService) private mobileLoginService: MobileLoginService,
        @Inject(AppDataService) private appDataService: AppDataService,
        @Inject(DomSanitizer) private domSanitizer: DomSanitizer,
        @Inject(Router) private router: Router,
        @Inject(NgZone) private ngZone: NgZone
    ) {}

    ngOnInit() {
        this.getWebUrl = () => this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL;
        this.headerService.setDisplayRightContent(false);
        this.uiSelectedViewName = this.uiViewName_BY_IDS;

        if (this.guestPaymentStore.getViewedTc()) {
            this.registrationStore.setViewedTc(true);
            this.guestPaymentStore.setViewedTc(false);
        }

        // if valid view name (empty strings not being valid)
        if (this.registrationStore.getUiSelectedViewName()) {
            this.uiSelectedViewName = this.registrationStore.getUiSelectedViewName();
        }

        if (this.registrationStore.getHomeowner() != null)
            this.homeowner = this.registrationStore.getHomeowner();
        else if (this.guestPaymentStore.getHomeowner() != null)
            this.homeowner = this.guestPaymentStore.getHomeowner();

        if (this.registrationStore.getProperty() != null)
            this.property = this.registrationStore.getProperty();
        else if (this.guestPaymentStore.getProperty() != null)
            this.property = this.guestPaymentStore.getProperty();

        if (this.isAnyCouponDataPresent()) {
            this.uiSelectedViewName = this.uiViewName_BY_IDS;
        }

        if (this.isCouponDataPresent()) {
            this.updateDefaultPropertyAddress();
        }
    }

    defaultNickname() {
        if (this.property &&
            this.property.address &&
            this.property.address.line1 &&
            this.property.address.line1.toString().length > 0 &&
            !this.searched) {
            this.property.nickname = this.property.address.line1;
        }
    }

    isCouponDataPresent() {
        return (this.isPropertyCouponIdPresent() && this.isHoaCouponIdPresent() && this.isPmcCouponIdPresent());
    }

    isAnyCouponDataPresent() {
        return (this.isPropertyCouponIdPresent() ||
            (this.property && this.isHoaCouponIdPresent()) ||
            (this.property && this.property.hoa && this.isPmcCouponIdPresent()));
    }

    isPropertyCouponIdPresent() {
        return (this.property &&
            this.property.couponId &&
            this.property.couponId.toString().length > 0);
    }

    isHoaCouponIdPresent() {
        return (this.property.hoa &&
            this.property.hoa.couponId &&
            this.property.hoa.couponId.toString().length > 0);
    }

    isPmcCouponIdPresent() {
        return (this.property.hoa.pmc &&
            this.property.hoa.pmc.couponId &&
            this.property.hoa.pmc.couponId.toString().length > 0);
    }

    isAddressPresent() {
        return this.property && this.property.address
            && this.property.address.line1 && this.property.address.line1.toString().length > 0
            && this.property.address.city && this.property.address.city.toString().length > 0
            && this.property.address.state && this.property.address.state.toString().length > 0
            && this.property.address.postalCode && this.property.address.postalCode.toString().length > 0;

    }

    isAddressFieldValid(value) {
        return value && value.length > 0 && value.toLowerCase() !== 'null'
    }

    isAddressValid(address: Address) {
        return (this.isAddressFieldValid(address.line1) || this.isAddressFieldValid(address.addressLine1))
            && this.isAddressFieldValid(address.city)
            && this.isAddressFieldValid(address.state)
            && this.isAddressFieldValid(address.postalCode)
            && new RegExp('^[0-9]{5}$').test(address.postalCode);
    }

    startCorrectingAddress() {
        this.isCorrectingAddress = true;
    }

    stopCorrectingAddress() {
        this.isCorrectingAddress = false;
    }

    cleanAddress(address: Address) {
        if (address.postalCode !== null) {
            address.postalCode = address.postalCode.substr(0, 5);
        }
    }

    setPropertyAddress(address: Address) {
        this.cleanAddress(address);
        if (!this.isAddressValid(address)) {
            this.startCorrectingAddress();
        } else {
            this.stopCorrectingAddress();
        }

        this.property.address = address;
        this.setPropertyAddressSubject.next();
    }

    updateDefaultPropertyAddress() {
        this.stopCorrectingAddress();
        this.defaultPropertyAddress().then(() => {}, () => {});
    }

    defaultPropertyAddress(): Promise<string | void> {

        return new Promise<string | void>((resolve, reject) => {

            if (this.isCouponDataPresent()) {
                this.propertyApi.propertyAddressGet(true,
                    this.property.hoa.pmc.couponId,
                    this.property.hoa.couponId,
                    this.property.couponId)
                    .pipe(take(1)).subscribe((resp) => {
                        if (!resp) {
                            reject();
                            this.dialog.open(RegistrationNoPropertyDialog, {
                                data: {
                                    pmcId: this.property.hoa.pmc.couponId
                                }
                            });
                        } else if (resp.line1) {
                            if (!this.isAddressPresent()) {
                                this.setPropertyAddress(resp);
                                this.defaultNickname();
                                resolve();
                            } else {
                                if (this.property.address.line1 === resp.line1 &&
                                (this.property.address.line2 === undefined || this.property.address.line2 === resp.line2) &&
                                this.property.address.city === resp.city &&
                                this.property.address.state === resp.state &&
                                this.property.address.postalCode === resp.postalCode) {
                                // DO NOTHING = things match
                                    resolve();
                                } else {
                                    let propertyAddress = "Address Line 1: " + resp.addressLine1 + "<br>";
                                    if (resp.addressLine2)
                                        propertyAddress = propertyAddress + "Address Line 2: " + resp.addressLine2 + "<br>";
                                    if (resp.unit)
                                        propertyAddress = propertyAddress + "Unit#: " + resp.unit + "<br>";
                                    propertyAddress = propertyAddress + "City: " + resp.city + "<br> State: " +
                                    resp.state + "<br>Postal Code: " + resp.postalCode;

                                    // Retrieve pmc details
                                    this.contactApi.pmcOrganizationDetailsGET(
                                        true,
                                        this.property.hoa.pmc.couponId
                                    ).pipe(take(1)).subscribe((data) => {
                                        if (data == null) {
                                            reject('No pmc found with Coupon ID: ' + this.property.hoa.pmc.couponId)
                                            return
                                        }

                                        const pmcDataName = data.name;
                                        const pmcCouponId = this.property.hoa.pmc.couponId;

                                        let dialogRef;
                                        if (!this.isAddressValid(resp)) {
                                            dialogRef = this.dialog.open(RegistrationAltAddressNeedsCorrectionDialog, {
                                                data: {
                                                    propertyAddress: this.domSanitizer.bypassSecurityTrustHtml(propertyAddress),
                                                    contactUrl: this.getPmcContactUrl(pmcCouponId),
                                                    pmcName: pmcDataName
                                                }
                                            });
                                        } else {
                                            dialogRef = this.dialog.open(RegistrationAltAddressDialog, {
                                                data: {
                                                    propertyAddress: this.domSanitizer.bypassSecurityTrustHtml(propertyAddress),
                                                    contactUrl: this.getPmcContactUrl(pmcCouponId),
                                                    pmcName: pmcDataName
                                                }
                                            });
                                        }
                                        dialogRef.afterClosed().pipe(take(1)).subscribe(value => {
                                            if (value === 'A') {
                                                this.setPropertyAddress(resp);
                                                resolve();
                                            } else {
                                                reject();
                                            }
                                        }, () => {});
                                    });
                                }
                            }
                        } else {
                            this.setPropertyAddressSubject.next();
                            this.propertyApi.propertiesValidateGet(true,
                                this.property.hoa.pmc.couponId,
                                this.property.hoa.couponId,
                                this.property.couponId)
                                .pipe(take(1)).subscribe((resp) => {
                                    if (resp.valid === true) {
                                        resolve();
                                    } else {
                                        reject('Invalid property');
                                    }
                                }, () => {
                                    //todo this should really be changed by the service to not be a regular 500 error,
                                    // so we can specifically catch the invalid property errors.
                                    reject('Invalid property');
                                });
                        }
                        return resp;
                    }, (err) => {
                        this.networkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((resp) => {
                                if (resp === true) {
                                    this.defaultPropertyAddress();
                                }
                                reject();
                            });
                    });
            } else {
                reject();
            }

        });
    }

    openDefaultCouponData() {
        if (this.isAddressPresent()) {
            this.defaultCouponData();
        }
    }

    defaultCouponData(): Promise<string | void> {

        return new Promise<string | void>((resolve, reject) => {

            // if each of the required fields for address is defined then call api to retrieve coupon data
            if (this.isAddressPresent()) {
                this.propertyApi.couponGet(true, this.property.address)
                    .pipe(take(1)).subscribe((data) => {
                        if (data.hoaCouponId && data.pmcCouponId) {
                            if (!this.isCouponDataPresent()) {
                                if (this.property.hoa) {
                                    this.property.hoa.couponId = data.hoaCouponId;
                                } else {
                                    this.property.hoa = { couponId: data.hoaCouponId };
                                }
                                this.property.couponId = data.propertyCouponId;
                                if (this.property.hoa.pmc) {
                                    this.property.hoa.pmc.couponId = data.pmcCouponId;
                                } else {
                                    this.property.hoa.pmc = { couponId: data.pmcCouponId };
                                }

                                if (data.propertyCouponId === null &&
                                data.hoaCouponId === null &&
                                data.pmcCouponId === null) {
                                    this.disableInputsProperty = false;
                                    this.property.hoa.couponId = undefined;
                                    this.property.hoa.pmc.couponId = undefined;
                                    this.property.couponId = undefined;
                                }
                                resolve();
                            } else {
                                if (this.property.couponId === data.propertyCouponId &&
                                this.property.hoa.couponId === data.hoaCouponId &&
                                this.property.hoa.pmc.couponId === data.pmcCouponId) {
                                // DO NOTHING - Things match
                                    resolve();
                                } else {
                                    const dialogRef = this.dialog.open(RegistrationAltDetailsCouponDialog, {
                                        data: { resp: data }
                                    });
                                    dialogRef.afterClosed().pipe().subscribe(value => {
                                        if (value === 'A') {
                                            if (this.property.hoa) {
                                                this.property.hoa.couponId = data.hoaCouponId;
                                            } else {
                                                this.property.hoa = { couponId: data.hoaCouponId };
                                            }
                                            this.property.couponId = data.propertyCouponId;
                                            if (this.property.hoa.pmc) {
                                                this.property.hoa.pmc.couponId = data.pmcCouponId;
                                            } else {
                                                this.property.hoa.pmc = { couponId: data.pmcCouponId };
                                            }
                                            resolve();
                                        } else {
                                            reject();
                                        }
                                    });
                                }
                            }
                        } else {
                        // lets check for non val users
                            if (this.isCouponDataPresent()) {
                                this.propertyApi.propertiesValidateGet(true,
                                    this.property.hoa.pmc.couponId,
                                    this.property.hoa.couponId,
                                    this.property.couponId)
                                    .pipe(take(1)).subscribe((data) => {
                                        if (data.valid === true) {
                                            resolve();
                                        } else {
                                            reject('Invalid property');
                                        }
                                    });
                            } else {
                                reject();
                            }
                        }

                    //return data;
                    }, (err) => {
                        this.disableInputsProperty = false;
                        this.networkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((resp) => {
                                if (resp === true) {
                                    this.defaultCouponData();
                                }
                                reject();
                            });
                    });
            } else {
                reject();
            }

        })
    }

    invalidCheck(addressError) {
        if (addressError.hasOwnProperty("searching")) {
            this.isLoadingFindMyProperty = addressError["searching"];
        }
        for (let key in addressError) {
            if (addressError[key]) {
                this.invalidCheckVar = true;
                return;
            }
        }
        this.invalidCheckVar = false;
    }

    invalid() {
        if (this.isCouponDataPresent()) {

        }
        return false;
    }

    cancel() {
        this.registrationStore.clearAllData();
        this.$window.location.replace(this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL);
    }

    submit() {
        // TODO - I may have entered my address, no property found and entered property IDS that return an address.
        //  need to validate they match first.
        this.spinnerService.showSpinner();
        if (this.isCorrectingAddress) {
            //if correcting address we will skip calling
            //defaultPropertyAddress to match the
            //coupon ID address against what is entered
            //since it will always be different
            this.submitStep2();
        } else {
            this.defaultPropertyAddress().then(() => {
                this.submitStep2();
            }, (err) => {
                if (err === 'Invalid property') {
                    this.dialog.open(RegistrationNoPropertyDialog, {
                        data: { pmcId: this.property.hoa.pmc.couponId }
                    });
                }
                this.spinnerService.closeSpinner();
            });
        }
    }

    submitStep2() {
        if (!this.isAddressValid(this.property.address)) {
            this.dialog.open(RegistrationInvalidAddressDialog);
            this.spinnerService.closeSpinner();
        } else {
            this.propertyApi.propertiesValidateGet(true,
                this.property.hoa.pmc.couponId,
                this.property.hoa.couponId,
                this.property.couponId)
                .pipe(take(1)).subscribe((resp) => {
                    if (resp.valid === true && (resp.doNotProcess === false || resp.doNotProcessCode === "L01")) {
                        this.successfullyLocatedProperty()
                    // we found your property (step 2 complete)
                    } else {
                        if (resp.doNotProcessCode === "D01") {
                            this.dialog.open(RegistrationStopHoldDialog, {
                                data: { reasonCode: resp.doNotProcessCode }
                            });
                            this.spinnerService.closeSpinner();
                        } else if (resp.doNotProcessCode === "M01") {
                            this.dialog.open(RegistrationStopHoldDialog, {
                                data: { reasonCode: resp.doNotProcessCode }
                            });
                            this.spinnerService.closeSpinner();
                        } else { //No Matching record found.
                            this.dialog.open(RegistrationNoPropertyDialog, {
                                data: { pmcId: this.property.hoa.pmc.couponId }
                            });
                            this.spinnerService.closeSpinner();
                        }

                    }
                }, (err) => {
                    this.networkErrorService.handleNetworkError(err, true)
                        .pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.submit();
                            }
                        });
                });
        }
    }

    successfullyLocatedProperty() {
        let dialogRef = this.dialog.open(RegistrationFoundPropertyDialog);
        dialogRef.afterClosed().pipe(take(1)).subscribe(value => {
            this.registrationStore.setHomeowner(this.homeowner);
            this.registrationStore.setProperty(this.property);

            //we know we won't ever get to this spot if the person is amui user and is a hoa homeowner.
            if (this.registrationStore.isAmuiUser()) {
                this.addEntitlement();

            } else {
                if (value && value === 'continue')
                    this.router.navigateByUrl('/createAccount');
            }

        });
    }

    prepareHomeowner() {
        const homeowner = this.registrationStore.getHomeowner()
        let phones = homeowner.contactInformation.phones;

        const propAddr = this.registrationStore.getProperty().address;

        homeowner.contactInformation.phones = [{
            ...phones[0],
            type: "home",
        }]

        homeowner.contactInformation.mailingAddress = {
            line1: propAddr.line1,
            line2: propAddr.line2,
            unit: propAddr.unit,
            postalCode: propAddr.postalCode,
            state: propAddr.state,
            city: propAddr.city,
            country: propAddr.country || "USA",
        }

        return homeowner;
    }

    showRegistrationCompleteDialog() {
        let dialogRef = this.dialog.open(SecurityQuestionsConfirmDialog);
        dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
            // logout in the unlikely event of a previously logged in user existing during a new or GP registration.
            let idToken: string = this.$window.sessionStorage.getItem("hoapay_idToken");
            if (!idToken) {
                this.$window.location.href =
                    this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL + "/registered/#/properties";
            } else {
                this.$window.location.href = this.appDataService.appConfig.get_APP_ENV().OAUTH_LOGOUT_URL + 'id_token_hint=' +
                    idToken + '&post_logout_redirect_uri=' + this.appDataService.appConfig.get_APP_ENV().OAUTH_LOGOUT_REDIRECT_URL;
            }
        });
    }

    addEntitlement() {
        this.spinnerService.showSpinner();

        let registrationRequest: RegistrationRequest = {
            emailAddress: this.homeowner.contactInformation.email.value,
            firstName: this.homeowner.firstName,
            lastName: this.homeowner.lastName,
            existing: true,
            homeownerId: null,
            phone: null
        };

        let hoMarketingAgreement: HomeownerMarketingAgreement = {
            acceptedMarketing: this.registrationStore.getMarketingAgreement(),
            acceptedMaketingDate: String(Date.now()),
            partyId: null
        }

        let completeRegistrationRequest: CompleteRegistrationRequest = {
            homeowner: this.prepareHomeowner(),
            properties: [this.propertyApi.formatProperty(this.registrationStore.getProperty())],
            amuiRegistrationRequest: registrationRequest,
            marketingAgreement: hoMarketingAgreement
        };

        this.registrationApi.completeRegisterUser(completeRegistrationRequest)
            .pipe(take(1)).subscribe( { next: () => {
                this.spinnerService.closeSpinner();
                this.registrationStore.clearAllData();
                this.showRegistrationCompleteDialog();
            }, error: (error) => {
                this.spinnerService.closeSpinner();
                if (error.error.errors && error.error.errors.length > 0) {
                    let errorMessage = '';
                    if (error.error.message) {
                        errorMessage = error.error.message;
                    }
                    error.error.errors.forEach(msg => {
                        errorMessage += '<br><br>' + msg;
                    })
                    this.errorHandlerService.handleNetworkError(error, true, errorMessage)
                        .pipe().subscribe(() =>  {
                        })
                } else {
                    this.networkErrorService.handleNetworkError(error, true)
                        .pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.addEntitlement();
                            }
                        });
                }
            } });
    }
}


